module.exports = __webpack_public_path__ + "static/turtle-creek-house05-627615bbf0df98ca03684dc712ae060d.jpg";